import { useState } from "react";
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Dashboard as DashIcon,
  AccountTree as LokacijeIcon,
} from "@mui/icons-material";
import { Outlet, useNavigate, useLocation } from "react-router-dom"; // Dodan useLocation
import ProfilePopover from "./ProfilePopover";

const drawerWidth = 240;

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Za praćenje aktivne rute

  const menuItems = [
    { text: "Dashboard", icon: <DashIcon />, path: "/dashboard" },
    { text: "Lokacije", icon: <LokacijeIcon />, path: "/lokacija" }, // Nova stavka
  ];

  const drawer = (
    <Box sx={{ height: "100%", backgroundColor: "#fcfcfc" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "center", py: 2 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 800, color: "#284c7a", letterSpacing: 1 }}
        >
          G3 SPIRITS
        </Typography>
      </Toolbar>

      <Divider sx={{ mb: 2, opacity: 0.6 }} />

      <List sx={{ px: 1.5 }}>
        {menuItems.map((item) => {
          // Provjera je li ruta aktivna
          const isActive = location.pathname === item.path;

          return (
            <ListItem key={item.text} disablePadding sx={{ mb: 1 }}>
              <ListItemButton
                onClick={() => {
                  navigate(item.path);
                  setMobileOpen(false);
                }}
                sx={{
                  borderRadius: "12px",
                  backgroundColor: isActive
                    ? "rgba(40, 76, 122, 0.08)"
                    : "transparent",
                  color: isActive ? "#284c7a" : "#637381",
                  "&:hover": {
                    backgroundColor: "rgba(40, 76, 122, 0.04)",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "#284c7a" : "#637381",
                    minWidth: 45,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: "0.9rem",
                    fontWeight: isActive ? 700 : 500,
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(40, 76, 122, 0.95)",
          backdropFilter: "blur(8px)",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setMobileOpen(!mobileOpen)}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, fontWeight: 700, fontSize: "1.1rem" }}
          >
            CRM Panel
          </Typography>

          <ProfilePopover />
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          minHeight: "100vh",
          backgroundColor: "#f4f6f8", // Blago siva pozadina za bolji kontrast kartica
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
